import ApiResponse from "src/interfaces/ApiResponse";
import {
  ConfiguracaoPayload,
  ConfiguracoesFiltrarParams,
} from "src/pages/Privada/Configuracoes/Sistema/Cadastro/SistemaCadastro.Dto";
import { SistemaFiltrarDto } from "src/pages/Privada/Configuracoes/Sistema/Sistema.Dto";
import { NFCeConsultaInputDto, NFCeDto } from "src/pages/Privada/Fiscal/NFCe/NFCe.Dto";
import { TributacaoCadastroDto } from "src/pages/Privada/Fiscal/Tributacao/Tributacao/Cadastro/TributacaoCadastro.Dto";
import { TributacaoFiltrarDto } from "src/pages/Privada/Fiscal/Tributacao/Tributacao/Tributacao.Dto";
import api from "./api";
import { NFeDto } from "src/pages/Privada/Fiscal/NFe/NFe.Dto";
import { NFeEventoCadastroDto } from "src/pages/Privada/Fiscal/NFe/Evento/NFe.Evento.Dto";
import { TributacaoCfopCadastroDto } from "src/pages/Privada/Fiscal/Tributacao/Cfop/TributacaoCfopCadastro.Dto";
import { TributacaoCfopImpostoCadastroDto } from "src/pages/Privada/Fiscal/Tributacao/Imposto/TributacaoCfopImpostoCadastro.Dto";
import { CTeDto, CTeFiltrarDto } from "src/pages/Privada/Fiscal/CTe/CTe.Dto";
import {
  CTeEventoCadastroDto,
  CTeEventoFiltrarDto,
} from "src/pages/Privada/Fiscal/CTe/Evento/CTe.Evento.Dto";
import {
  TributacaoMensagemDto,
  TributacaoMensagemFiltrarDto,
} from "src/pages/Privada/Fiscal/Tributacao/Mensagem/TributacaoMensagem.Dto";
import { TributacaoMensagemCadastroDto } from "src/pages/Privada/Fiscal/Tributacao/Mensagem/Cadastro/TributacaoMensagemCadastro.Dto";
import moment from "moment";
import {
  MDFeFiltrarDto,
  MDFeInput,
} from "src/pages/Privada/Fiscal/MDFe/MDFe.Dto";
import { MDFeEventoInput } from "src/pages/Privada/Fiscal/MDFe/Evento/MDFe.Evento.Dto";

export function TributacaoFiltrar(input: TributacaoFiltrarDto) {
  return api.get<ApiResponse>(
    process.env.REACT_APP_API_BASE_URL_FISCAL + "/tributacao/filtrar",
    {
      params: input,
    },
  );
}

export function TributacaoBuscarPorId(id: string) {
  return api.get<ApiResponse>(
    process.env.REACT_APP_API_BASE_URL_FISCAL +
    "/tributacao/buscar-por-id?id=" +
    id,
  );
}

export function TributacaoBuscarPorOperacao(operacao: number) {
  return api.get<ApiResponse>(
    process.env.REACT_APP_API_BASE_URL_FISCAL +
    "/tributacao/filtrar?TipoOperacao=" +
    operacao,
  );
}

export function TributacaoBuscarPorPadraoEmissaoCTe() {
  return api.get<ApiResponse>(
    process.env.REACT_APP_API_BASE_URL_FISCAL +
    "/tributacao/filtrar?PadraoEmissaoCTe=true",
  );
}

export function TributacaoIncluir(input: TributacaoCadastroDto) {
  return api.post<ApiResponse>(
    process.env.REACT_APP_API_BASE_URL_FISCAL + "/tributacao/incluir",
    input,
  );
}

export function TributacaoAtualizar(input: TributacaoCadastroDto) {
  return api.put<ApiResponse>(
    process.env.REACT_APP_API_BASE_URL_FISCAL + "/tributacao/atualizar",
    input,
  );
}

export function TributacaoExcluir(id: number) {
  return api.delete<ApiResponse>(
    process.env.REACT_APP_API_BASE_URL_FISCAL + "/tributacao/excluir?id=" + id,
  );
}

export function TributacaoMensagemIncluir(input: TributacaoMensagemCadastroDto) {
  return api.post<ApiResponse>(
    process.env.REACT_APP_API_BASE_URL_FISCAL + "/tributacao/mensagem/incluir",
    input,
  );
}

export function TributacaoMensagemAtualizar(
  input: TributacaoMensagemCadastroDto,
) {
  return api.put<ApiResponse>(
    process.env.REACT_APP_API_BASE_URL_FISCAL + "/tributacao/mensagem/atualizar",
    input,
  );
}

export function TributacaoMensagemExcluir(id: number) {
  return api.delete<ApiResponse>(
    process.env.REACT_APP_API_BASE_URL_FISCAL +
      "/tributacao/mensagem/excluir?id=" +
      id,
  );
}

export function TributacaoMensagemFiltrar(
  input?: TributacaoMensagemFiltrarDto,
) {
  return api.get<ApiResponse>(
    process.env.REACT_APP_API_BASE_URL_FISCAL + "/tributacao/mensagem/filtrar",
    {
      params: input,
    },
  );
}

export async function TributacaoMensagemBuscarPorId(id: number | string) {
  const response = await TributacaoMensagemFiltrar({ id: Number(id) });
  if (response.data.success) {
    const data = response.data.data;
    if (Array.isArray(data)) {
      return {
        ...response,
        data: {
          ...response.data,
          data:
            data.find((item: TributacaoMensagemDto) => item.id === Number(id)) ||
            data[0],
        },
      };
    }
  }
  return response;
}

export function TributacaoCfopBuscarPorTributacaoId(id: string) {
  return api.get<ApiResponse>(
    process.env.REACT_APP_API_BASE_URL_FISCAL +
    "/tributacao/cfop/buscar-por-tributacao-id?tributacaoId=" +
    id,
  );
}

export function TributacaoCfopBuscarId(id: string) {
  return api.get<ApiResponse>(
    process.env.REACT_APP_API_BASE_URL_FISCAL +
    "/tributacao/cfop/buscar-por-id?id=" +
    id,
  );
}

export function TributacaoCfopIncluir(input: TributacaoCfopCadastroDto) {
  return api.post<ApiResponse>(
    process.env.REACT_APP_API_BASE_URL_FISCAL + "/tributacao/cfop/incluir",
    input,
  );
}

export function TributacaoCfopAtualizar(input: TributacaoCfopCadastroDto) {
  return api.put<ApiResponse>(
    process.env.REACT_APP_API_BASE_URL_FISCAL + "/tributacao/cfop/atualizar",
    input,
  );
}

export function TributacaoCfopExcluir(id: number) {
  return api.delete<ApiResponse>(
    process.env.REACT_APP_API_BASE_URL_FISCAL +
    "/tributacao/cfop/excluir?id=" +
    id,
  );
}

export function TributacaoCfopImpostoBuscarId(id: string) {
  return api.get<ApiResponse>(
    process.env.REACT_APP_API_BASE_URL_FISCAL +
    "/tributacao/imposto/buscar-por-id?id=" +
    id,
  );
}

export function TributacaoCfopImpostoIncluir(
  input: TributacaoCfopImpostoCadastroDto,
) {
  return api.post<ApiResponse>(
    process.env.REACT_APP_API_BASE_URL_FISCAL + "/tributacao/imposto/incluir",
    input,
  );
}

export function TributacaoCfopImpostoAlterar(
  input: TributacaoCfopImpostoCadastroDto,
) {
  return api.put<ApiResponse>(
    process.env.REACT_APP_API_BASE_URL_FISCAL + "/tributacao/imposto/atualizar",
    input,
  );
}

export function TributacaoCfopImpostoExcluir(id: number) {
  return api.delete<ApiResponse>(
    process.env.REACT_APP_API_BASE_URL_FISCAL +
    "/tributacao/imposto/excluir?id=" +
    id,
  );
}

export function TributacaoCfopImpostoCstIbsCbsBuscar() {
  return api.get(
    process.env.REACT_APP_API_BASE_URL_FISCAL +
    "/tributacao/imposto/buscar-cst",
  );
}

export function NFCeIncluir(input: NFCeDto) {
  return api.post<ApiResponse>(
    process.env.REACT_APP_API_BASE_URL_FISCAL + "/nfce/incluir",
    input,
  );
}

export function NFCeEnviar(id: number) {
  return api.post<ApiResponse>(
    process.env.REACT_APP_API_BASE_URL_FISCAL + "/nfce/enviar?id=" + id,
  );
}

export function NFCeImprimir(id: number) {
  return api.get(
    process.env.REACT_APP_API_BASE_URL_FISCAL + "/nfce/imprimir/danfe",
    {
      params: { id },
      responseType: "blob",
    },
  );
}

export function NFCeBuscarUltima(serie: number) {
  return api.get(
    process.env.REACT_APP_API_BASE_URL_FISCAL +
    "/nfce/buscar-ultima?serie=" +
    serie,
  );
}

export function NFCeFiltrar(input: NFCeConsultaInputDto) {
  const params: any = {};

  if (input.codigoStatusEnvio) {
    params.codigoStatusEnvio = input.codigoStatusEnvio;
  }

  if (input.dataEmissaoInicial) {
    params.dataEmissaoInicial = moment(input.dataEmissaoInicial).format(
      "YYYY-MM-DD"
    );
  }

  if (input.dataEmissaoFinal) {
    params.dataEmissaoFinal = moment(input.dataEmissaoFinal).format(
      "YYYY-MM-DD"
    );
  }

  if (input.serie) {
    params.serie = input.serie;
  }

  return api.get<ApiResponse>(
    process.env.REACT_APP_API_BASE_URL_FISCAL + "/nfce/filtrar",
    {
      params,
    },
  );
}

export function NFCeExcluir(id: number) {
  return api.delete<ApiResponse>(
    process.env.REACT_APP_API_BASE_URL_FISCAL + "/nfce/excluir?id=" + id,
  );
}

export function ConfiguracaoFiltrar(params: SistemaFiltrarDto) {
  return api.get(
    process.env.REACT_APP_API_BASE_URL_FISCAL + "/configuracao/filtrar",
    {
      params,
    },
  );
}

export function NFCeBuscarXML(ids: number[], nomeArquivo: string) {
  const params = new URLSearchParams();

  ids.forEach((id) => params.append("ids", id.toString()));
  params.append("nomeArquivo", encodeURIComponent(nomeArquivo));

  return api.get(
    process.env.REACT_APP_API_BASE_URL_FISCAL +
    "/nfce/buscar-xml?" +
    params.toString(),
    {
      responseType: "blob",
    },
  );
}

export function ConfiguracaoIncluir(payload: ConfiguracaoPayload) {
  return api.post(
    process.env.REACT_APP_API_BASE_URL_FISCAL + "/configuracao/incluir",
    payload,
  );
}

export function ConfiguracaoAtualizar(payload: ConfiguracaoPayload) {
  return api.put(
    process.env.REACT_APP_API_BASE_URL_FISCAL + "/configuracao/atualizar",
    payload,
  );
}

export function ConfiguracoesFiltrar(params: ConfiguracoesFiltrarParams) {
  return api.get<ApiResponse>(
    process.env.REACT_APP_API_BASE_URL_FISCAL + "/configuracao/filtrar",
    {
      params,
    },
  );
}

export function NFCeConsultarSituacao(id: number) {
  return api.post<ApiResponse>(
    process.env.REACT_APP_API_BASE_URL_FISCAL +
    "/nfce/consultar-situacao?id=" +
    id,
  );
}

export function NFeIncluir(input: NFeDto) {
  return api.post<ApiResponse>(
    process.env.REACT_APP_API_BASE_URL_FISCAL + "/nfe/incluir",
    input,
  );
}

export function NFeFiltrar(input: NFCeConsultaInputDto) {
  const params: any = {};

  if (input.codigoStatusEnvio)
    params.codigoStatusEnvio = input.codigoStatusEnvio;

  if (input.dataEmissaoInicial)
    params.dataEmissaoInicial = moment(input.dataEmissaoInicial).format(
      "YYYY-MM-DD"
    );

  if (input.dataEmissaoFinal)
    params.dataEmissaoFinal = moment(input.dataEmissaoFinal).format(
      "YYYY-MM-DD"
    );

  if (input.serie) params.serie = input.serie;

  if (input.id) params.id = input.id;

  return api.get<ApiResponse>(
    process.env.REACT_APP_API_BASE_URL_FISCAL + "/nfe/filtrar",
    {
      params,
    },
  );
}

export function NFeExcluir(id: number) {
  return api.delete<ApiResponse>(
    process.env.REACT_APP_API_BASE_URL_FISCAL + "/nfe/excluir?id=" + id,
  );
}

export function NFeImprimir(id: number) {
  return api.get(
    process.env.REACT_APP_API_BASE_URL_FISCAL + "/nfe/imprimir/danfe?id=" + id,
    {
      responseType: "blob",
    },
  );
}

export function NFeConsultarSituacao(id: number) {
  return api.post<ApiResponse>(
    process.env.REACT_APP_API_BASE_URL_FISCAL +
    "/nfe/consultar-situacao?id=" +
    id,
  );
}

export function NFeBuscarXML(ids: number[], nomeArquivo: string) {
  const params = new URLSearchParams();

  ids.forEach((id) => params.append("ids", id.toString()));
  params.append("nomeArquivo", encodeURIComponent(nomeArquivo));

  return api.get(
    process.env.REACT_APP_API_BASE_URL_FISCAL +
    "/nfe/buscar-xml?" +
    params.toString(),
    {
      responseType: "blob",
    },
  );
}

export function NFeEnviar(id: number) {
  return api.post<ApiResponse>(
    process.env.REACT_APP_API_BASE_URL_FISCAL + "/nfe/enviar?id=" + id,
  );
}

export function NFeEventoFiltrar(nfeId: number) {
  return api.get<ApiResponse>(
    process.env.REACT_APP_API_BASE_URL_FISCAL +
    "/nfe/evento/filtrar?nfeId=" +
    nfeId,
  );
}

export function NFeEventoEnviar(id: number) {
  return api.post<ApiResponse>(
    process.env.REACT_APP_API_BASE_URL_FISCAL + "/nfe/evento/enviar?id=" + id,
  );
}

export function NFeEventoIncluir(input: NFeEventoCadastroDto) {
  return api.post<ApiResponse>(
    process.env.REACT_APP_API_BASE_URL_FISCAL + "/nfe/evento/incluir",
    input,
  );
}

export function NFeEventoExcluir(id: number) {
  return api.delete<ApiResponse>(
    process.env.REACT_APP_API_BASE_URL_FISCAL + "/nfe/evento/excluir?id=" + id,
  );
}

export function CTeIncluir(input: CTeDto) {
  return api.post<ApiResponse>(
    process.env.REACT_APP_API_BASE_URL_FISCAL + "/cte/incluir",
    input,
  );
}

export function CTeExcluir(id: number) {
  return api.delete<ApiResponse>(
    process.env.REACT_APP_API_BASE_URL_FISCAL + "/cte/excluir?id=" + id,
  );
}

export function CTeEnviar(id: number) {
  return api.post<ApiResponse>(
    process.env.REACT_APP_API_BASE_URL_FISCAL + "/cte/enviar?id=" + id,
  );
}

export function CTeConsultarSituacao(id: number) {
  return api.post<ApiResponse>(
    process.env.REACT_APP_API_BASE_URL_FISCAL +
    "/cte/consultar-situacao?id=" +
    id,
  );
}

export function CTeFiltrar(input: CTeFiltrarDto) {
  const params = new URLSearchParams();

  let codigosStatus: (string | number)[] = input.codigosStatusEnvio
    ? [...input.codigosStatusEnvio]
    : [];

  if (
    typeof input.codigoStatusEnvio === "string" &&
    input.codigoStatusEnvio.includes(",")
  ) {
    const splitCodes = input.codigoStatusEnvio
      .split(",")
      .map((c) => c.trim())
      .filter((c) => c !== "");
    codigosStatus = [...codigosStatus, ...splitCodes];
  } else if (
    input.codigoStatusEnvio !== undefined &&
    input.codigoStatusEnvio !== null &&
    input.codigoStatusEnvio !== "" &&
    input.codigoStatusEnvio !== "99"
  ) {
    if (codigosStatus.length === 0) {
      params.append("CodigoStatusEnvio", input.codigoStatusEnvio.toString());
    }
  }

  if (codigosStatus.length > 0) {
    codigosStatus.forEach((cod) => {
      params.append("CodigosStatusEnvio", cod.toString());
    });
  }

  if (input.dataEmissaoInicial) {
    params.append(
      "DataEmissaoInicial",
      input.dataEmissaoInicial.toISOString().slice(0, 10)
    );
  }

  if (input.dataEmissaoFinal) {
    params.append(
      "DataEmissaoFinal",
      input.dataEmissaoFinal.toISOString().slice(0, 10)
    );
  }

  if (input.serie) {
    params.append("Serie", input.serie.toString());
  }

  if (input.id) {
    params.append("Id", input.id.toString());
  }

  if (input.chaveAcesso) {
    params.append("ChaveAcesso", input.chaveAcesso);
  }

  if (input.codigoMunicipioDestinatario) {
    params.append(
      "CodigoMunicipioDestinatario",
      input.codigoMunicipioDestinatario.toString()
    );
  }

  if (input.codigoMunicipioRemetente) {
    params.append(
      "CodigoMunicipioRemetente",
      input.codigoMunicipioRemetente.toString()
    );
  }

  if (
    input.codigosMunicipioRemetente &&
    input.codigosMunicipioRemetente.length > 0
  ) {
    input.codigosMunicipioRemetente.forEach((cod) => {
      params.append("CodigosMunicipioRemetente", cod.toString());
    });
  }

  const queryString = params.toString();

  return api.get<ApiResponse>(
    process.env.REACT_APP_API_BASE_URL_FISCAL +
      "/cte/filtrar" +
      (queryString ? `?${queryString}` : "")
  );
}

export function CTeBuscarXML(ids: number[], nomeArquivo: string) {
  const params = new URLSearchParams();

  ids.forEach((id) => params.append("ids", id.toString()));
  params.append("nomeArquivo", encodeURIComponent(nomeArquivo));

  return api.get(
    process.env.REACT_APP_API_BASE_URL_FISCAL +
    "/cte/buscar-xml?" +
    params.toString(),
    {
      responseType: "blob",
    },
  );
}

export function CTeImprimir(id: number) {
  return api.get(
    process.env.REACT_APP_API_BASE_URL_FISCAL + "/cte/imprimir/dacte",
    {
      params: { id },
      responseType: "blob",
    },
  );
}

export function CTeEventoFiltrar(input: number | CTeEventoFiltrarDto) {
  const params = new URLSearchParams();

  if (typeof input === "number") {
    params.append("CTeId", input.toString());
  } else {
    if (input.id) params.append("Id", input.id.toString());
    if (input.cTeId) params.append("CTeId", input.cTeId.toString());
    if (input.status && input.status.length > 0) {
      input.status.forEach((st) => params.append("Status", st.toString()));
    }
  }

  return api.get<ApiResponse>(
    `${process.env.REACT_APP_API_BASE_URL_FISCAL}/cte/evento/filtrar?${params.toString()}`
  );
}

export function CTeEventoEnviar(id: number) {
  return api.post<ApiResponse>(
    `${process.env.REACT_APP_API_BASE_URL_FISCAL}/cte/evento/enviar?id=${id}`
  );
}

export function CTeEventoIncluir(input: CTeEventoCadastroDto) {
  return api.post<ApiResponse>(
    `${process.env.REACT_APP_API_BASE_URL_FISCAL}/cte/evento/incluir`,
    input
  );
}

export function CTeEventoExcluir(id: number) {
  return api.delete<ApiResponse>(
    `${process.env.REACT_APP_API_BASE_URL_FISCAL}/cte/evento/excluir?id=${id}`
  );
}

export function MDFeIncluir(input: MDFeInput) {
  return api.post<ApiResponse>(
    process.env.REACT_APP_API_BASE_URL_FISCAL + "/mdfe/incluir",
    input
  );
}

export function MDFeEnviar(id: number) {
  return api.post<ApiResponse>(
    process.env.REACT_APP_API_BASE_URL_FISCAL + "/mdfe/enviar?id=" + id
  );
}

export function MDFeConsultarSituacao(id: number) {
  return api.post<ApiResponse>(
    process.env.REACT_APP_API_BASE_URL_FISCAL +
      "/mdfe/consultar-situacao?id=" +
      id
  );
}

export function MDFeExcluir(id: number) {
  return api.delete<ApiResponse>(
    process.env.REACT_APP_API_BASE_URL_FISCAL + "/mdfe/excluir?id=" + id
  );
}

export function MDFeFiltrar(input: MDFeFiltrarDto) {
  const params: any = {};

  if (input.codigoStatusEnvio) {
    params.codigoStatusEnvio = input.codigoStatusEnvio;
  }

  if (input.dataEmissaoInicial) {
    params.dataEmissaoInicial = moment(input.dataEmissaoInicial).format(
      "YYYY-MM-DD"
    );
  }

  if (input.dataEmissaoFinal) {
    params.dataEmissaoFinal = moment(input.dataEmissaoFinal).format(
      "YYYY-MM-DD"
    );
  }

  if (input.serie) {
    params.serie = input.serie;
  }

  if (input.numeroMDFe) {
    params.numeroMDFe = input.numeroMDFe;
  }

  if (input.placa) {
    params.placa = input.placa;
  }

  if (input.id) {
    params.id = input.id;
  }

  return api.get<ApiResponse>(
    process.env.REACT_APP_API_BASE_URL_FISCAL + "/mdfe/filtrar",
    {
      params,
    }
  );
}

export function MDFeBuscarXML(ids: number[], nomeArquivo: string) {
  const params = new URLSearchParams();

  ids.forEach((id) => params.append("ids", id.toString()));
  params.append("nomeArquivo", encodeURIComponent(nomeArquivo));

  return api.get(
    process.env.REACT_APP_API_BASE_URL_FISCAL +
      "/mdfe/buscar-xml?" +
      params.toString(),
    {
      responseType: "blob",
    }
  );
}

export function MDFeImprimirDAMDFE(id: number) {
  return api.get(
    process.env.REACT_APP_API_BASE_URL_FISCAL + "/mdfe/imprimir/damdfe",
    {
      params: { id },
      responseType: "blob",
    }
  );
}

export function MDFeNaoEncerrados() {
  return api.get<ApiResponse>(
    process.env.REACT_APP_API_BASE_URL_FISCAL + "/mdfe/nao-encerrados"
  );
}

export function MDFeEventoIncluir(input: MDFeEventoInput) {
  return api.post<ApiResponse>(
    process.env.REACT_APP_API_BASE_URL_FISCAL + "/mdfe/evento/incluir",
    input
  );
}

export function MDFeEventoEnviar(id: number) {
  return api.post<ApiResponse>(
    process.env.REACT_APP_API_BASE_URL_FISCAL + "/mdfe/evento/enviar?id=" + id
  );
}

export function MDFeEventoFiltrar(mdfeId: number) {
  return api.get<ApiResponse>(
    process.env.REACT_APP_API_BASE_URL_FISCAL +
      "/mdfe/evento/filtrar?mdfeId=" +
      mdfeId
  );
}

export interface MDFeCIOTVeiculoInput {
  placa: string;
  numeroEixos: number;
  rntrcVeiculo?: string | null;
}

export interface MDFeCIOTCargaInput {
  codigoNaturezaCarga: number;
  pesoCarga: number;
  tipoCarga: number;
  contratantesCargaFracionada?: string[] | null;
}

export interface MDFeCIOTPagamentoInput {
  tipoPagamento: number;
  formaPagamento: number;
  cpfCnpjCreditado: string;
  chavePix?: string | null;
  identificadorPix?: string | null;
  codigoPagamento?: string | null;
  codigoInstituicaoFinanceira?: number | null;
  numeroAgencia?: string | null;
  numeroConta?: string | null;
  numeroParcela?: number | null;
  dataVencimento?: string | null;
  valorParcela?: number | null;
}

export interface MDFeCIOTIndicadoresInput {
  indAltoDesempenho: boolean;
  indRetornoVazio: boolean;
  composicaoVeicular: boolean;
}

export interface MDFeCIOTGerarInput {
  tipoOperacao: number;
  documentoResponsavel: string;
  documentoDestinatario?: string | null;
  rntrc: string;
  rntrcContratante?: string | null;
  valorFrete: number;
  dataInicioViagem: string;
  dataFimViagem: string;
  ufInicio: string;
  ufFim: string;
  codigoMunicipioInicio?: number | null;
  codigoMunicipioFim?: number | null;
  distanciaKm?: number | null;
  veiculos: MDFeCIOTVeiculoInput[];
  carga?: MDFeCIOTCargaInput | null;
  pagamentos: MDFeCIOTPagamentoInput[];
  indicadores?: MDFeCIOTIndicadoresInput | null;
  contingencia?: boolean;
  justificativaContingencia?: string | null;
  idOperacaoTransporte?: string | null;
  forcarNovo?: boolean;
}

export interface MDFeCIOTOutput {
  id: number;
  ciot: string;
  codigoVerificador: string;
  protocoloANTT?: string;
  documentoResponsavel: string;
  placaVeiculo: string;
  ufInicio: string;
  ufFim: string;
  valorFrete: number;
  status: number;
  dataCriacao: string;
  reutilizado: boolean;
  mensagem?: string;
}

export function MDFeGerarCIOT(input: MDFeCIOTGerarInput) {
  return api.post<ApiResponse>(
    process.env.REACT_APP_API_BASE_URL_FISCAL + "/mdfe/ciot/gerar",
    input
  );
}



